import api from '@/api'

export default {
    getTeamsLists(params :basemail.graphOption) : Promise<any> {
        return api.post({
            url: '/api/ISU_Graph/api/jointeams/',
            data : params 
        })
    },

    getchannelsList(params :basemail.graphOption) : Promise<any> {
        return api.post({
            url: '/api/ISU_Graph/api/channelslist/',
            data : params 
        })
    },

    getTeamsChannelsList(params :basemail.graphOption) : Promise<any> {
        return api.post({
            url: '/api/ISU_Graph/api/teamschannelslist/',
            data : params 
        })
    },

    getChannelsDetail(params :basemail.graphOption) : Promise<any> {
        return api.post({
            url: '/api/ISU_Graph/api/channelsdetail/',
            data : params 
        })
    },

    getoneDriveList(params :basemail.graphOption) : Promise<any> {
        return api.post({
            url: '/api/ISU_Graph/api/onedrivelistitem/',
            data : params 
        })
    },

    getoneDriveListChildren(params :basemail.graphOption) : Promise<any> {
        return api.post({
            url: '/api/ISU_Graph/api/onedrivelistChildrenitem/',
            data : params 
        })
    },

    getoneDriveItemsChildren(params :basemail.graphOption) : Promise<any> {
        return api.post({
            url: '/api/ISU_Graph/api/drivesitemschildren/',
            data : params 
        })
    },    
    
}
